export const metierData = [
  {
    metier: "Aide-soignant",
    slug: "aide-soignant",
    romes: ["J1501"],
  },
  {
    metier: "Ambulancier",
    slug: "ambulancier",
    romes: ["J1305"],
  },
  {
    metier: "Architecte d'intérieur",
    slug: "architecte-d-interieur",
    romes: ["F1102"],
  },
  {
    metier: "Assistant administratif",
    slug: "assistant-administratif",
    romes: ["M1607"],
  },
  {
    metier: "Assistant dentaire",
    slug: "assistant-dentaire",
    romes: ["J1312"],
  },
  {
    metier: "Assistant marketing",
    slug: "assistant-marketing",
    romes: ["M1705"],
  },
  {
    metier: "Assistant ressources humaines",
    slug: "assistant-ressources-humaines",
    romes: ["M1501"],
  },
  {
    metier: "Assistant social",
    slug: "assistant-social",
    romes: ["K1201"],
  },
  {
    metier: "Auxiliaire de puériculture",
    slug: "auxiliaire-de-puericulture",
    romes: ["J1304"],
  },
  {
    metier: "Auxiliaire vétérinaire",
    slug: "auxiliaire-veterinaire",
    romes: ["A1501"],
  },
  {
    metier: "Chargé de communication",
    slug: "charge-de-communication",
    romes: ["E1103"],
  },
  {
    metier: "Chargé de recrutement",
    slug: "charge-de-recrutement",
    romes: ["M1502"],
  },
  {
    metier: "Coiffeur",
    slug: "coiffeur",
    romes: ["D1202"],
  },
  {
    metier: "Comptable",
    slug: "comptable",
    romes: ["M1203"],
  },
  {
    metier: "Contrôleur de gestion",
    slug: "controleur-de-gestion",
    romes: ["M1204"],
  },
  {
    metier: "Data analyst",
    slug: "data-analyst",
    romes: ["M1403"],
  },
  {
    metier: "Développeur cybersécurité",
    slug: "developpeur-cybersecurite",
    romes: ["M1802"],
  },
  {
    metier: "Développeur web",
    slug: "developpeur-web",
    romes: ["M1805"],
  },
  {
    metier: "Éducateur spécialisé",
    slug: "educateur-specialise",
    romes: ["K1207"],
  },
  {
    metier: "Électricien",
    slug: "electricien",
    romes: ["F1602"],
  },
  {
    metier: "Esthéticien",
    slug: "estheticien",
    romes: ["D1208"],
  },
  {
    metier: "Gestionnaire de paie",
    slug: "gestionnaire-de-paie",
    romes: ["M1507"],
  },
  {
    metier: "Juriste",
    slug: "juriste",
    romes: ["K1903"],
  },
  {
    metier: "Manipulateur en radiologie",
    slug: "manipulateur-en-radiologie",
    romes: ["J1306"],
  },
  {
    metier: "Moniteur-éducateur",
    slug: "moniteur-educateur",
    romes: ["K1207"],
  },
  {
    metier: "Notaire",
    slug: "notaire",
    romes: ["K1901"],
  },
  {
    metier: "Pâtissier",
    slug: "patissier",
    romes: ["D1104"],
  },
  {
    metier: "Plombier",
    slug: "plombier",
    romes: ["F1603"],
  },
  {
    metier: "Préparateur en pharmacie",
    slug: "preparateur-en-pharmacie",
    romes: ["J1307"],
  },
  {
    metier: "Secrétaire médicale",
    slug: "secretaire-medicale",
    romes: ["M1609"],
  },
]
